import { Directive, Input, Renderer, ElementRef } from '@angular/core';

@Directive({
  selector: '[appFocus]'
})
export class FocusDirective {

  @Input('appFocus') isFocused: boolean;

  constructor(private hostElement: ElementRef, private renderer: Renderer) { }
  

  ngOnInit(): void {
  
    if (this.isFocused) {
      this.renderer.invokeElementMethod(this.hostElement.nativeElement,'focus')
    }
  }
}
